import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#00ACC1',
        secondary: '#b885f7',
        accent: '#e57373',
        error: '#AD1457',
        warning: '#FB8C00',
        info: '#2196f3',
        success: '#4caf50'
      },
      dark: {
        primary: '#00ACC1',
        secondary: '#b885f7',
        accent: '#e57373',
        error: '#AD1457',
        warning: '#FB8C00',
        info: '#2196f3',
        success: '#4caf50'
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
})
